import * as React from 'react';
import { createComponent } from '@lit/react';
import { ColorPickerWC } from './color-picker.wc';
import {
  GenerateComponentTypeWithChildren,
  GeneratePropsWithRef,
} from '../../component-types-generics';

export type ColorPickerProps =
  GenerateComponentTypeWithChildren<ColorPickerWC> & {
    onChange?: React.ChangeEventHandler<ColorPickerWC>;
  };

export type ColorPickerPropsWithRef = GeneratePropsWithRef<ColorPickerProps>;

export const ColorPicker = createComponent({
  tagName: ColorPickerWC.tagname,
  elementClass: ColorPickerWC,
  react: React,
  events: {
    onChange: 'change',
    onInput: 'input',
    onFocus: 'focus',
    onBlur: 'blur',
  },
}) as ColorPickerPropsWithRef;
